import najaInstance from 'naja';
import LazyLoad from 'vanilla-lazyload';

export default class LazyLoading {
    private lazyLoad: typeof LazyLoad;

    public constructor(naja: typeof najaInstance) {
        this.lazyLoad = new LazyLoad({
            elements_selector: 'img[data-src]',
            callback_reveal: this.loadingStarted.bind(this),
            callback_loaded: this.loadingFinished.bind(this),
            load_delay: 400,
        });

        naja.addEventListener('success', () => this.lazyLoad.update());
    }

    private loadingStarted(loadedElement: HTMLElement): void {
        const spinner = this.findRelatedSpinner(loadedElement);

        if (spinner === null) {
            return;
        }

        this.toggleVisibility(loadedElement, false);
        this.toggleVisibility(spinner, true);
    }

    private loadingFinished(loadedElement: HTMLElement): void {
        const spinner = this.findRelatedSpinner(loadedElement);

        if (spinner === null) {
            return;
        }

        this.toggleVisibility(spinner, false);
        this.toggleVisibility(loadedElement, true);
    }

    private findRelatedSpinner(element: HTMLElement): HTMLElement|null {
        const spinners = element.parentElement!.querySelectorAll<HTMLElement>('.spinner');

        if (spinners.length !== 1) {
            return null;
        }

        return spinners[0];
    }

    private toggleVisibility(element: HTMLElement, visible: boolean): void {
        if (visible) {
            element.classList.remove('invisible');
        } else {
            element.classList.add('invisible');
        }
    }
}
